import {Component} from '@angular/core';
import {AppComponent} from './app.component';

@Component({
    selector: 'app-footer',
    template: `
        <div style="justify-content: space-between;" class="layout-footer p-d-flex p-ai-center p-p-4 p-shadow-2">
            <img id="footer-logo" [src]="'assets/layout/images/tivi2.png'" width="200" height="50" alt="manager-footer-logo">
            <p-tag styleClass="p-mr-8" value="Version 1.0.71" [rounded]="true"></p-tag>
        </div>
    `
})
export class AppFooterComponent {
    constructor(public app: AppComponent) {}
}

